<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small text-center" v-loading="isUploading">
      <el-upload
        drag
        class="upload-demo"
        action
        :before-upload="beforeUpload"
        :accept="accepts"
        element-loading-text="正在上传文件，请不要中途关闭此窗口，上传成功后，将自动关闭。"
        element-loading-spinner="el-icon-loading"
        :multiple="isMulti"
        ref="upload"
        :on-success="onUploadSuccess"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>选择文件</em>
        </div>
        <div v-if="!!accepts" class="el-upload__tip" slot="tip">只能上传格式为{{accepts}}的文件</div>
      </el-upload>
      <br />
      <div v-if="files.length > 0">
        <div v-for="(file, index) in files" :key="index">
          选择文件： {{ file.name }}
          <el-button type="text" size="medium" @click="removeFile(index)">移除</el-button>
        </div>
      </div>
      <br />
      <br />
      <br />
      <el-button
        v-if="files.length > 0"
        type="primary"
        :disabled="isUploading"
        @click="uploadUsingFrontEnd"
      >点击上传</el-button>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col class="footer-left">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getFileContainerList } from "../../service/common.service";
import {
  getSharedAccessSignature,
  saveUploadFile,
  saveUploadFiles,
} from "../../service/blobStorage.service";
import {
  uploadFileToBlobStorage,
  uploadFilesToBlobStorage,
} from "../../filters/blobStorage";

export default {
  props: {
    isVisible: Boolean,
    type: Number, //上传文件类型，根据后台FileStorageType配置
    accepts: String, //接受的文件类型
    isAutoSave: Boolean,
    maxNameLength: Number,
    isMulti: Boolean,
    isCDN: Boolean
  },
  data() {
    return {
      isUploading: false,
      showError: false,
      errorMessage: "",
      fileTypeList: [],
      containerName: "",
      files: [],
      containerList: [],
      sasKey: "",
    };
  },
  created() {
    this.getSupportedFileTypeList();
    getSharedAccessSignature().then((result) => {
      if (!!result && result.success) {
        this.sasKey = result.data;
      }
    });
    getFileContainerList().then((result) => {
      if (!!result && result.success) {
        this.containerList = result.data;
        this.getContainerName();
      }
    });
  },
  methods: {
    onExceed(files, fileList) {},
    fileChange(file, fileList) {},
    beforeUpload(file) {
      this.clearMessages();

      if (this.isFileExist(file)) {
        return false;
      }
  
      let fileType = file.getMimeType();
      if (this.fileTypeList.length > 0 && this.fileTypeList.indexOf(fileType) < 0) {
        this.showError = true;
        this.errorMessage = file.name + "不是所支持的文件格式";
        return false;
      }

      if (
        !!this.maxNameLength &&
        this.getFileName(file.name).length > this.maxNameLength
      ) {
        this.showError = true;
        this.errorMessage = "文件名不可超过" + this.maxNameLength + "个字符!";
        return false;
      }

      this.files.push(file);
      return false;
    },
    uploadUsingFrontEnd() {
      this.showError = false;
      if (!this.containerName) {
        this.showError = true;
        this.errorMessage = "未找到对应的容器";
        return false;
      }

      if (this.files.length === 0) {
        this.showError = true;
        this.errorMessage = "请选择要上传的文件";
        return false;
      }

      if (!this.sasKey) {
        this.showError = true;
        this.errorMessage = "上传配置出错";
        return false;
      }

      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        if (file.size > 1024 * 1024 * 35) {
          this.showError = true;
          this.errorMessage = `文件 ${file.name} 大小超出限制（35M）`;
          return false;
        }
      }

      this.isUploading = true;
      if (this.isMulti)
        uploadFilesToBlobStorage(
          this.files,
          this.containerName,
          this.sasKey,
          this.uploadCallBack
        );
      else
        uploadFileToBlobStorage(
          this.files[0],
          this.containerName,
          this.sasKey,
          this.uploadCallBack,
          !!this.isCDN
        );
    },
    uploadCallBack(result) {
      console.log(result);
      if (result.isSuccess) {
        let data = [];
        if (this.isMulti) {
          data = [];
          result.data.forEach((m) => {
            data.push({
              fileStorageType: this.type,
              sourceFileName: m.originalFile.name,
              uploadFileName: m.uploadFileName,
              fileSize: m.originalFile.size,
            });
          });
        } else {
          data = {
            fileStorageType: this.type,
            sourceFileName: result.data.originalFile.name,
            uploadFileName: result.data.uploadFileName,
            fileSize: result.data.originalFile.size,
          };
        }

        this.onUploadSuccess(data);
      } else {
        this.onUploadError(result);
      }
    },
    onUploadSuccess(data) {
      this.clearMessages(true);
      this.$refs.upload.clearFiles();

      if (this.isAutoSave) {
        if (this.isMulti)
          saveUploadFiles(data)
            .then((result) => {
              if (!!result && result.success) {
                this.$emit("blobUploaded", result.data);
              } else {
                this.errorMessage = "文件上传出错";
              }
              this.isUploading = false;
            })
            .catch(() => {
              this.isUploading = false;
            });
        else
          saveUploadFile(data)
            .then((result) => {
              if (!!result && result.success) {
                this.$emit("blobUploaded", result.data);
              } else {
                this.errorMessage = "文件上传出错";
              }
              this.isUploading = false;
            })
            .catch(() => {
              this.isUploading = false;
            });
      } else {
        this.isUploading = false;
        this.$emit("blobUploaded", data);
      }
    },
    onUploadError(err) {
      this.isUploading = false;
      this.showError = true;
      this.errorMessage = err.errorMessage;
      this.$emit("blobUploadError");
    },
    clearMessages(isForcedClean) {
      this.showError = false;
      this.errorMessage = "";
      if (isForcedClean || !this.isMulti) this.files = [];
    },
    getSupportedFileTypeList() {
      if (!!this.accepts) {
        let exts = this.accepts.split(",");
        this.fileTypeList = File.convertToFileTypeList(exts);
      }
    },
    getContainerName() {
      if (
        !!this.type &&
        !!this.containerList &&
        this.containerList.length > 0
      ) {
        let container = this.containerList.find((i) => i.Key == this.type);
        if (!!container) {
          this.containerName = container.Value;
        }
      }
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    isFileExist(file) {
      let result = false;

      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].name == file.name) {
          result = true;
          break;
        }
      }

      return result;
    },
    getFileName(text) {
      var pattern = /\.{1}[a-z]{1,}$/;
      if (pattern.exec(text) !== null) {
        return text.slice(0, pattern.exec(text).index);
      } else {
        return text;
      }
    },
  },
  watch: {
    isVisible: function () {
      if (!this.isVisible) {
        this.clearMessages(true);
      }
      this.isUploading = false;
    },
    accepts: function () {
      this.getSupportedFileTypeList();
    },
    type: function () {
      this.getContainerName();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fileHandler/blobUploader.vue